import { ChangeEvent, FC, useCallback } from "react";
import { Box, TextareaAutosize, TextareaAutosizeProps } from "@mui/material";

interface FilterValueWithBatchInputTextAreaProps {
  value: string;
  onChange: (value: string) => void;
}

export const FilterValueWithBatchInputTextArea: FC<
  FilterValueWithBatchInputTextAreaProps
> = ({ value, onChange }) => {
  const changeHandler = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  return (
    <Box
      maxHeight={200}
      overflow="auto"
      borderRadius={2}
      border={1}
      p={1}
      borderColor="grey.300"
      bgcolor="white"
    >
      <TextareaAutosize
        value={value}
        onChange={changeHandler}
        aria-label="maximum height"
        placeholder="Values: e.g., value1, value2, value3..."
        style={style}
      />
    </Box>
  );
};

const style: TextareaAutosizeProps["style"] = {
  width: "100%",
  height: "170px",
  resize: "none",
  border: "none",
  outline: "none",
};
